// extracted by mini-css-extract-plugin
module.exports = {"page":"add_page_38tQm","card-wrapper":"add_card-wrapper_1a39v","footer":"add_footer_1cU1o"};